import { Helmet } from 'react-helmet';
import StepWizard from '../../../commons/StepWizard/StepWizard';
import { loginCommercialSteps } from './LoginCommercial.data';

export default () => {
  return (
    <>
      <Helmet>
        <title>Connexion commercial</title>
      </Helmet>
      <StepWizard steps={loginCommercialSteps} />
    </>
  );
};
